"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBHeaderCarousel", {
  enumerable: true,
  get: function get() {
    return _SVBHeaderCarousel.default;
  }
});
var _SVBHeaderCarousel = _interopRequireDefault(require("./src/SVBHeaderCarousel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }